import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPartner = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5M13.3332 2.60661C14.048 2.79192 14.681 3.20933 15.1329 3.79333C15.5848 4.37733 15.83 5.09485 15.83 5.83327C15.83 6.5717 15.5848 7.28922 15.1329 7.87322C14.681 8.45722 14.048 8.87463 13.3332 9.05994M18.3332 17.4999V15.8332C18.3326 15.0947 18.0868 14.3772 17.6343 13.7935C17.1818 13.2098 16.5483 12.7929 15.8332 12.6082M10.8332 5.83333C10.8332 7.67428 9.34079 9.16667 7.49984 9.16667C5.65889 9.16667 4.1665 7.67428 4.1665 5.83333C4.1665 3.99238 5.65889 2.5 7.49984 2.5C9.34079 2.5 10.8332 3.99238 10.8332 5.83333Z",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPartner;
